// src/pages/Contacts/index.js (versão corrigida)
import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { Facebook, Instagram, WhatsApp, Close } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";
import Checkbox from "@material-ui/core/Checkbox";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { alpha } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@material-ui/icons/Visibility";
import RefreshIcon from "@material-ui/icons/Refresh";
import GetAppIcon from "@material-ui/icons/GetApp";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal/";
import ContactDeleteConfirmModal from "../../components/ContactDeleteConfirmModal";

import { i18n } from "../../translate/i18n";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from "../../utils/formatSerializedId";
import { v4 as uuidv4 } from "uuid";

import { Backup, ContactPhone, DeleteSweep } from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import getContactPictureUrl from "../../helpers/getContactPictureUrl";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    const contacts = action.payload;
    const newContacts = [];

    contacts.forEach((contact) => {
      const contactIndex = state.findIndex((c) => c.id === contact.id);
      if (contactIndex !== -1) {
        state[contactIndex] = contact;
      } else {
        newContacts.push(contact);
      }
    });

    return [...state, ...newContacts];
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    } else {
      return [contact, ...state];
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "BULK_DELETE_CONTACTS") {
    const contactIds = action.payload;
    return state.filter(contact => !contactIds.includes(contact.id));
  }

  if (action.type === "DELETE_ALL_CONTACTS") {
    const { excludeIds = [] } = action.payload;
    return state.filter(contact => excludeIds.includes(contact.id));
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "SET_TOTAL_COUNT") {
    // Não altera o estado, mas permite rastrear o total
    return state;
  }
};

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    gap: theme.spacing(3),
    backgroundColor: "transparent",
    minHeight: 0,
    overflow: "visible",
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(2),
    },
  },
  pageHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    marginBottom: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
  },
  headerTitle: {
    fontSize: 28,
    fontWeight: 800,
    color: "#111827",
    lineHeight: 1.15,
  },
  headerSubtitle: {
    color: "#6b7280",
    marginTop: 4,
  },
  headerActions: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    justifyContent: "flex-end",
    paddingRight: theme.spacing(0.5),
    maxWidth: "100%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      paddingRight: 0,
      "& > *": {
        flex: "1 1 100%",
      },
    },
  },
  actionButton: {
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 700,
    minHeight: 40,
    boxShadow: "none",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  summaryCard: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    padding: theme.spacing(2.5),
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  summaryIcon: {
    width: 42,
    height: 42,
    borderRadius: 12,
    display: "grid",
    placeItems: "center",
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
  },
  summaryLabel: {
    fontSize: 13,
    color: "#6b7280",
    fontWeight: 600,
  },
  summaryValue: {
    fontSize: 24,
    fontWeight: 800,
    color: "#111827",
    lineHeight: 1.1,
  },
  filterCard: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    padding: theme.spacing(2.5),
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
  },
  filtersRow: {
    display: "grid",
    gridTemplateColumns: "minmax(260px, 1.5fr) minmax(220px, 1fr) repeat(3, minmax(150px, 0.7fr))",
    gap: theme.spacing(2),
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
    "& > *": {
      width: "100%",
      minWidth: 0,
    },
  },
  roundedInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "#f9fafb",
    },
  },
  mainPaper: {
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    minHeight: 360,
    padding: 0,
    overflow: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    boxShadow: "0 14px 36px rgba(15, 23, 42, 0.06)",
    backgroundColor: "#fff",
    ...theme.scrollbarStyles,
  },
  table: {
    minWidth: 1060,
    "& .MuiTableCell-head": {
      backgroundColor: "#f8fafc",
      color: "#475569",
      fontSize: 12,
      fontWeight: 800,
      textTransform: "uppercase",
      letterSpacing: 0,
      borderBottom: "1px solid #e5e7eb",
      padding: theme.spacing(2),
    },
    "& .MuiTableCell-body": {
      borderBottom: "1px solid #eef2f7",
      padding: theme.spacing(1.75, 2),
    },
  },
  tableRow: {
    transition: "background-color 0.18s ease",
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
  },
  avatarCell: {
    width: "60px",
    padding: theme.spacing(1),
  },
  idCell: {
    width: "80px",
  },
  checkboxCell: {
    width: "48px",
    padding: theme.spacing(0, 1),
  },
  clickableAvatar: {
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    width: 42,
    height: 42,
    fontWeight: 800,
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.main,
    "&:hover": {
      transform: "scale(1.06)",
    },
  },
  contactCell: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    minWidth: 230,
  },
  contactName: {
    fontWeight: 800,
    color: "#111827",
  },
  contactMeta: {
    fontSize: 12,
    color: "#6b7280",
    marginTop: 2,
  },
  tagWrap: {
    display: "flex",
    gap: 4,
    flexWrap: "wrap",
    maxWidth: 210,
  },
  tagChip: {
    height: 24,
    borderRadius: 999,
    fontWeight: 700,
    fontSize: 11,
    border: "1px solid #dbe4ee",
    color: "#334155",
    backgroundColor: "#f8fafc",
  },
  statusBadge: {
    height: 26,
    borderRadius: 999,
    fontWeight: 800,
    fontSize: 12,
  },
  activeBadge: {
    color: "#047857",
    backgroundColor: "#d1fae5",
  },
  blockedBadge: {
    color: "#b91c1c",
    backgroundColor: "#fee2e2",
  },
  walletText: {
    color: "#374151",
    fontWeight: 600,
  },
  mutedText: {
    color: "#9ca3af",
  },
  emptyState: {
    height: 240,
    display: "grid",
    placeItems: "center",
    color: "#6b7280",
    fontWeight: 700,
  },
  imageDialog: {
    "& .MuiDialog-paper": {
      maxWidth: "500px",
      maxHeight: "500px",
      borderRadius: 16,
    },
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: theme.spacing(1),
  },
  profileImage: {
    width: "100%",
    height: "auto",
    maxWidth: "400px",
    maxHeight: "400px",
    objectFit: "contain",
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    minHeight: 48,
  },
  toolbarHighlight: {
    backgroundColor: alpha(theme.palette.primary.main, 0.25),
  },
  toolbarTitle: {
    flex: '1 1 100%',
    fontWeight: 600,
  },
  bulkActions: {
    display: "flex",
    gap: theme.spacing(1),
  },
  detailsDialog: {
    "& .MuiDialog-paper": {
      borderRadius: 18,
    },
  },
  detailsHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2.5),
    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.12)}, #ffffff)`,
  },
  detailsAvatar: {
    width: 72,
    height: 72,
    fontSize: 28,
    fontWeight: 800,
    backgroundColor: theme.palette.primary.main,
  },
  detailCard: {
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    padding: theme.spacing(1.5),
    backgroundColor: "#fff",
    minHeight: 88,
  },
  detailLabel: {
    fontSize: 12,
    color: "#6b7280",
    fontWeight: 700,
    marginBottom: 6,
  },
  detailValue: {
    color: "#111827",
    fontWeight: 800,
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [totalContactsCount, setTotalContactsCount] = useState(0);

  // Estados para seleção múltipla
  const [selectedContacts, setSelectedContacts] = useState(new Set());
  const [selectAllMode, setSelectAllMode] = useState(false); // true = todos da empresa, false = apenas da página

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);
  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  const [statusFilter, setStatusFilter] = useState("all");
  const [walletFilter, setWalletFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [rowMenuAnchor, setRowMenuAnchor] = useState(null);
  const [rowMenuContact, setRowMenuContact] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsContact, setDetailsContact] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  
  // Estados para exclusão múltipla com confirmação tipada
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [deleteType, setDeleteType] = useState(''); // 'selected' ou 'all'
  
  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const { setCurrentTicket } = useContext(TicketsContext);

  // Estados para o modal de imagem
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedContactName, setSelectedContactName] = useState('');

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);
  
  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);

      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
  }, []);

  // Funções para seleção múltipla CORRIGIDAS
  const handleSelectContact = (contactId) => {
    const newSelected = new Set(selectedContacts);
    if (newSelected.has(contactId)) {
      newSelected.delete(contactId);
    } else {
      newSelected.add(contactId);
    }
    setSelectedContacts(newSelected);
    setSelectAllMode(false); // Desativa modo "todos da empresa" quando seleciona individualmente
  };

  const handleSelectAllContacts = () => {
    if (selectAllMode) {
      // Se já está em modo "todos", desmarcar tudo
      setSelectedContacts(new Set());
      setSelectAllMode(false);
    } else {
      // Verificar se todos da página atual estão selecionados
      const currentPageIds = contacts.map(contact => contact.id);
      const allCurrentSelected = currentPageIds.every(id => selectedContacts.has(id));
      
      if (allCurrentSelected && selectedContacts.size === currentPageIds.length) {
        // Se todos da página estão selecionados, ativar modo "todos da empresa"
        setSelectAllMode(true);
        setSelectedContacts(new Set()); // Limpar seleção individual
      } else {
        // Selecionar todos da página atual
        setSelectedContacts(new Set(currentPageIds));
        setSelectAllMode(false);
      }
    }
  };

  // Limpar seleção quando contatos mudam
  useEffect(() => {
    setSelectedContacts(new Set());
    setSelectAllMode(false);
  }, [searchParam, selectedTags, statusFilter, walletFilter]);

  // Função para obter contagem correta
  const getSelectedCount = () => {
    if (selectAllMode) {
      return totalContactsCount;
    }
    return selectedContacts.size;
  };

  // Função para obter texto do botão
  const getSelectionButtonText = () => {
    if (selectAllMode) {
      return `Excluir Todos (${totalContactsCount})`;
    }
    if (selectedContacts.size > 0) {
      return `Excluir Selecionados (${selectedContacts.size})`;
    }
    return "Excluir";
  };

  // Funções para exclusão múltipla CORRIGIDAS
  const handleBulkDeleteClick = () => {
    if (selectAllMode) {
      setDeleteType('all');
    } else if (selectedContacts.size > 0) {
      setDeleteType('selected');
    } else {
      toast.warning("Selecione pelo menos um contato para excluir");
      return;
    }
    setDeleteConfirmModalOpen(true);
  };

  const handleBulkDeleteConfirm = async () => {
    try {
      if (deleteType === 'all') {
        await api.delete("/contacts/all", {
          data: {
            confirmation: "DELETE_ALL_CONTACTS",
            excludeIds: []
          }
        });
        toast.success(`Todos os ${totalContactsCount} contatos foram excluídos`);
      } else {
        const contactIds = Array.from(selectedContacts);
        await api.post("/contacts/bulk-delete", { contactIds });
        toast.success(`${contactIds.length} contatos excluídos com sucesso`);
      }
      
      // Resetar seleções
      setSelectedContacts(new Set());
      setSelectAllMode(false);
      
      // Atualizar lista
      setSearchParam("");
      setPageNumber(1);
      
    } catch (err) {
      toastError(err);
    } finally {
      setDeleteConfirmModalOpen(false);
      setDeleteType('');
    }
  };

  const handleDeleteAllClick = () => {
    setDeleteType('all');
    setDeleteConfirmModalOpen(true);
  };

  // Função para abrir modal da imagem
  const handleOpenImageModal = (imageUrl, contactName) => {
    setSelectedImage(imageUrl);
    setSelectedContactName(contactName);
    setImageModalOpen(true);
  };

  // Função para fechar modal da imagem
  const handleCloseImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage('');
    setSelectedContactName('');
  };

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam, selectedTags]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: {
              searchParam,
              pageNumber,
              contactTag: JSON.stringify(selectedTags),
            },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setHasMore(data.hasMore);
          setTotalContactsCount(data.count); // Armazenar contagem total
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, selectedTags, refreshKey]);

  useEffect(() => {
    const companyId = user.companyId;

    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        setTotalContactsCount(prev => Math.max(0, prev - 1));
      }

      if (data.action === "bulk-delete") {
        dispatch({ type: "BULK_DELETE_CONTACTS", payload: data.contactIds });
        setTotalContactsCount(prev => Math.max(0, prev - data.contactIds.length));
      }

      if (data.action === "delete-all") {
        dispatch({ type: "DELETE_ALL_CONTACTS", payload: { excludeIds: data.excludeIds } });
        setTotalContactsCount(data.excludeIds.length);
      }
    };
    
    socket.on(`company-${companyId}-contact`, onContactEvent);

    return () => {
      socket.off(`company-${companyId}-contact`, onContactEvent);
    };
  }, [socket]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      toast.success("Contato bloqueado");
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      toast.success("Contato desbloqueado");
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setUnBlockingContact(null);
  };

  const handleimportContact = async () => {
    try {
      await api.post("/contacts/import");
      history.go(0);
      setImportContacts(false);
    } catch (err) {
      toastError(err);
      setImportContacts(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  // Determinar qual ação de confirmação executar para modais simples
  const getConfirmAction = () => {
    if (deletingContact) return () => handleDeleteContact(deletingContact.id);
    if (blockingContact) return () => handleBlockContact(blockingContact.id);
    if (unBlockingContact) return () => handleUnBlockContact(unBlockingContact.id);
    if (ImportContacts) return handleimportContact;
    return handleImportExcel;
  };

  // Determinar título do modal de confirmação simples
  const getConfirmTitle = () => {
    if (deletingContact) return `${i18n.t("contacts.confirmationModal.deleteTitle")} ${deletingContact.name}?`;
    if (blockingContact) return `Bloquear Contato ${blockingContact.name}?`;
    if (unBlockingContact) return `Desbloquear Contato ${unBlockingContact.name}?`;
    if (ImportContacts) return i18n.t("contacts.confirmationModal.importTitlte");
    return i18n.t("contactListItems.confirmationModal.importTitlte");
  };

  // Determinar mensagem do modal de confirmação simples
  const getConfirmMessage = () => {
    if (exportContact) return i18n.t("contacts.confirmationModal.exportContact");
    if (deletingContact) return i18n.t("contacts.confirmationModal.deleteMessage");
    if (blockingContact) return i18n.t("contacts.confirmationModal.blockContact");
    if (unBlockingContact) return i18n.t("contacts.confirmationModal.unblockContact");
    if (ImportContacts) return i18n.t("contacts.confirmationModal.importMessage");
    return i18n.t("contactListItems.confirmationModal.importMessage");
  };

  const selectedCount = getSelectedCount();
  const isAnyContactSelected = selectAllMode || selectedContacts.size > 0;

  // Status do checkbox "selecionar todos"
  const selectAllCheckboxStatus = () => {
    if (selectAllMode) return { checked: true, indeterminate: false };
    
    const currentPageIds = contacts.map(contact => contact.id);
    const selectedInCurrentPage = currentPageIds.filter(id => selectedContacts.has(id)).length;
    
    if (selectedInCurrentPage === 0) {
      return { checked: false, indeterminate: false };
    } else if (selectedInCurrentPage === currentPageIds.length) {
      return { checked: true, indeterminate: false };
    } else {
      return { checked: false, indeterminate: true };
    }
  };

  const checkboxStatus = selectAllCheckboxStatus();

  const formatPhoneNumber = (contact) => {
    if (!contact?.number) return "-";

    if (enableLGPD && hideNum && user.profile === "user") {
      if (contact.isGroup) return contact.number;

      const formatted = formatSerializedId(contact?.number);
      if (formatted === null) {
        return contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2);
      }

      return formatted?.slice(0, -6) + "**-**" + contact?.number?.slice(-2);
    }

    return contact.isGroup ? contact.number : formatSerializedId(contact?.number);
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("pt-BR");
  };

  const getInitials = (name = "") => {
    const parts = name.trim().split(" ").filter(Boolean);
    if (!parts.length) return "?";
    return parts.slice(0, 2).map((part) => part[0]).join("").toUpperCase();
  };

  const getWalletName = (contact) => {
    if (contact?.contactWallets && contact.contactWallets.length > 0) {
      return contact.contactWallets[0].wallet?.name || "Usuário não encontrado";
    }
    return "Não atribuído";
  };

  const getWalletId = (contact) => {
    if (contact?.contactWallets && contact.contactWallets.length > 0) {
      return contact.contactWallets[0].wallet?.id || "unknown";
    }
    return "unassigned";
  };

  const walletOptions = contacts.reduce((options, contact) => {
    const id = getWalletId(contact);
    if (!options.some((option) => option.id === id)) {
      options.push({ id, name: getWalletName(contact) });
    }
    return options;
  }, []);

  const filteredContacts = contacts.filter((contact) => {
    const matchesStatus =
      statusFilter === "all" ||
      (statusFilter === "active" && contact.active) ||
      (statusFilter === "blocked" && !contact.active);
    const matchesWallet =
      walletFilter === "all" || String(getWalletId(contact)) === String(walletFilter);

    return matchesStatus && matchesWallet;
  });

  const displayedContacts = filteredContacts.slice(0, rowsPerPage);
  const activeContactsCount = contacts.filter((contact) => contact.active).length;
  const blockedContactsCount = contacts.filter((contact) => !contact.active).length;
  const unassignedContactsCount = contacts.filter(
    (contact) => !contact.contactWallets || contact.contactWallets.length === 0
  ).length;

  const closeRowMenu = () => {
    setRowMenuAnchor(null);
    setRowMenuContact(null);
  };

  const openRowMenu = (event, contact) => {
    setRowMenuAnchor(event.currentTarget);
    setRowMenuContact(contact);
  };

  const handleOpenDetails = async (contact) => {
    closeRowMenu();
    setDetailsOpen(true);
    setDetailsContact(contact);
    setDetailsLoading(true);

    try {
      const { data } = await api.get(`/contacts/${contact.id}`);
      setDetailsContact(data);
    } catch (err) {
      toastError(err);
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleCloseDetails = () => {
    setDetailsOpen(false);
    setDetailsContact(null);
    setDetailsLoading(false);
  };

  const handleOpenConversation = (contact) => {
    closeRowMenu();
    setDetailsOpen(false);
    setContactTicket(contact);
    setNewTicketModalOpen(true);
  };

  const handleRefreshContacts = () => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <MainContainer className={classes.mainContainer}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>
      
      {/* Modal de confirmação tipada para exclusão */}
      <ContactDeleteConfirmModal
        open={deleteConfirmModalOpen}
        onClose={() => setDeleteConfirmModalOpen(false)}
        onConfirm={handleBulkDeleteConfirm}
        deleteType={deleteType}
        selectedCount={selectedContacts.size}
        totalCount={totalContactsCount}
      />
      
      {/* Modal para visualizar imagem de perfil */}
      <Dialog
        open={imageModalOpen}
        onClose={handleCloseImageModal}
        className={classes.imageDialog}
        maxWidth="md"
      >
        <DialogTitle className={classes.dialogTitle}>
          <span>Foto de Perfil - {selectedContactName}</span>
          <IconButton onClick={handleCloseImageModal} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedImage ? (
            <img
              src={selectedImage}
              alt={`Foto de perfil de ${selectedContactName}`}
              className={classes.profileImage}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '200px',
              color: '#666'
            }}>
              Imagem não disponível
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de confirmação simples para outras ações */}
      <ConfirmationModal
        title={getConfirmTitle()}
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={getConfirmAction()}
      >
        {getConfirmMessage()}
      </ConfirmationModal>
      
      <ConfirmationModal
        title={i18n.t("contacts.confirmationModal.importChat")}
        open={confirmChatsOpen}
        onClose={setConfirmChatsOpen}
        onConfirm={(e) => handleimportChats()}
      >
        {i18n.t("contacts.confirmationModal.wantImport")}
      </ConfirmationModal>

      <div className={classes.pageHeader}>
        <div>
          <Typography className={classes.headerTitle}>Contatos</Typography>
          <Typography className={classes.headerSubtitle}>
            Gerencie todos os contatos da empresa
          </Typography>
          {isAnyContactSelected && (
            <Typography variant="body2" color="secondary">
              {selectedCount} selecionado(s) {selectAllMode && "(todos)"}
            </Typography>
          )}
        </div>
        <div className={classes.headerActions}>
          <PopupState variant="popover" popupId="contacts-export-menu">
            {(popupState) => (
              <React.Fragment>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.actionButton}
                  startIcon={<GetAppIcon />}
                  {...bindTrigger(popupState)}
                >
                  Exportar
                </Button>
                <Menu {...bindMenu(popupState)}>
                  <Can
                    role={user.profile}
                    perform="contacts-page:deleteContact"
                    yes={() => (
                      <MenuItem
                        onClick={() => {
                          setImportContactModalOpen(true);
                          popupState.close();
                        }}
                      >
                        <GetAppIcon fontSize="small" color="primary" style={{ marginRight: 10 }} />
                        Exportar contatos
                      </MenuItem>
                    )}
                  />
                  <MenuItem
                    onClick={() => {
                      setImportContactModalOpen(true);
                      popupState.close();
                    }}
                  >
                    <Backup fontSize="small" color="primary" style={{ marginRight: 10 }} />
                    Baixar modelo
                  </MenuItem>
                </Menu>
              </React.Fragment>
            )}
          </PopupState>

          <PopupState variant="popover" popupId="contacts-import-menu">
            {(popupState) => (
              <React.Fragment>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.actionButton}
                  startIcon={<CloudUploadIcon />}
                  {...bindTrigger(popupState)}
                >
                  Importar
                </Button>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem
                    onClick={() => {
                      setConfirmOpen(true);
                      setImportContacts(true);
                      popupState.close();
                    }}
                  >
                    <ContactPhone fontSize="small" color="primary" style={{ marginRight: 10 }} />
                    {i18n.t("contacts.menu.importYourPhone")}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setImportContactModalOpen(true);
                      popupState.close();
                    }}
                  >
                    <Backup fontSize="small" color="primary" style={{ marginRight: 10 }} />
                    {i18n.t("contacts.menu.importToExcel")}
                  </MenuItem>
                  <Can
                    role={user.profile}
                    perform="contacts-page:deleteAllContacts"
                    yes={() => (
                      <MenuItem
                        onClick={() => {
                          handleDeleteAllClick();
                          popupState.close();
                        }}
                        style={{ color: "#dc2626" }}
                      >
                        <DeleteSweep fontSize="small" style={{ marginRight: 10, color: "#dc2626" }} />
                        Excluir todos os contatos
                      </MenuItem>
                    )}
                  />
                </Menu>
              </React.Fragment>
            )}
          </PopupState>

          <Tooltip title="Atualizar lista">
            <Button
              variant="outlined"
              color="primary"
              className={classes.actionButton}
              startIcon={<RefreshIcon />}
              onClick={handleRefreshContacts}
            >
              Atualizar
            </Button>
          </Tooltip>
          <Button
            variant="contained"
            color="primary"
            className={classes.actionButton}
            startIcon={<PersonAddIcon />}
            onClick={handleOpenContactModal}
          >
            Adicionar
          </Button>
        </div>
      </div>

      {importContactModalOpen && (
        <ContactImportWpModal
          isOpen={importContactModalOpen}
          handleClose={() => setImportContactModalOpen(false)}
          selectedTags={selectedTags}
          hideNum={hideNum}
          userProfile={user.profile}
        />
      )}

      <div className={classes.summaryGrid}>
        <div className={classes.summaryCard}>
          <div className={classes.summaryIcon}><PeopleAltIcon /></div>
          <div>
            <Typography className={classes.summaryLabel}>Total de contatos</Typography>
            <Typography className={classes.summaryValue}>{totalContactsCount}</Typography>
          </div>
        </div>
        <div className={classes.summaryCard}>
          <div className={classes.summaryIcon}><CheckCircleIcon /></div>
          <div>
            <Typography className={classes.summaryLabel}>Ativos</Typography>
            <Typography className={classes.summaryValue}>{activeContactsCount}</Typography>
          </div>
        </div>
        <div className={classes.summaryCard}>
          <div className={classes.summaryIcon}><BlockIcon /></div>
          <div>
            <Typography className={classes.summaryLabel}>Bloqueados</Typography>
            <Typography className={classes.summaryValue}>{blockedContactsCount}</Typography>
          </div>
        </div>
        <div className={classes.summaryCard}>
          <div className={classes.summaryIcon}><AssignmentIndIcon /></div>
          <div>
            <Typography className={classes.summaryLabel}>Sem carteira</Typography>
            <Typography className={classes.summaryValue}>{unassignedContactsCount}</Typography>
          </div>
        </div>
      </div>

      <Paper className={classes.filterCard} elevation={0}>
        <div className={classes.filtersRow}>
          <TextField
            className={classes.roundedInput}
            placeholder="Buscar por nome, telefone ou email"
            type="search"
            value={searchParam}
            onChange={handleSearch}
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="primary" />
                </InputAdornment>
              ),
            }}
          />
          <div className={classes.roundedInput}>
            <TagsFilter onFiltered={handleSelectedTags} selectedIds={selectedTags} />
          </div>
          <FormControl variant="outlined" size="small" className={classes.roundedInput}>
            <InputLabel>Status</InputLabel>
            <Select
              value={statusFilter}
              onChange={(event) => setStatusFilter(event.target.value)}
              label="Status"
            >
              <MenuItem value="all">Todos</MenuItem>
              <MenuItem value="active">Ativos</MenuItem>
              <MenuItem value="blocked">Bloqueados</MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" className={classes.roundedInput}>
            <InputLabel>Carteira</InputLabel>
            <Select
              value={walletFilter}
              onChange={(event) => setWalletFilter(event.target.value)}
              label="Carteira"
            >
              <MenuItem value="all">Todas</MenuItem>
              {walletOptions.map((wallet) => (
                <MenuItem key={wallet.id} value={wallet.id}>
                  {wallet.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" className={classes.roundedInput}>
            <InputLabel>Itens</InputLabel>
            <Select
              value={rowsPerPage}
              onChange={(event) => setRowsPerPage(event.target.value)}
              label="Itens"
            >
              <MenuItem value={10}>10 por página</MenuItem>
              <MenuItem value={20}>20 por página</MenuItem>
              <MenuItem value={50}>50 por página</MenuItem>
              <MenuItem value={100}>100 por página</MenuItem>
            </Select>
          </FormControl>
        </div>
      </Paper>

      <Paper className={classes.mainPaper} variant="outlined" onScroll={handleScroll}>
        <input
          style={{ display: "none" }}
          id="upload"
          name="file"
          type="file"
          accept=".xls,.xlsx"
          onChange={() => {
            setConfirmOpen(true);
          }}
          ref={fileUploadRef}
        />

        {/* Toolbar para ações em lote */}
        {isAnyContactSelected && (
          <Toolbar className={`${classes.toolbar} ${classes.toolbarHighlight}`}>
            <Typography className={classes.toolbarTitle} color="inherit" variant="subtitle1">
              {selectedCount} contato(s) selecionado(s) {selectAllMode && '(TODOS OS CONTATOS)'}
            </Typography>
            <div className={classes.bulkActions}>
              <Tooltip title="Cancelar seleção">
                <Button
                  size="small"
                  onClick={() => {
                    setSelectedContacts(new Set());
                    setSelectAllMode(false);
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title={selectAllMode ? "Excluir todos os contatos" : "Excluir selecionados"}>
                <IconButton
                  color="inherit"
                  onClick={handleBulkDeleteClick}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Toolbar>
        )}

        <Table size="small" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.checkboxCell}>
                <Checkbox
                  indeterminate={checkboxStatus.indeterminate}
                  checked={checkboxStatus.checked}
                  onChange={handleSelectAllContacts}
                  disabled={contacts.length === 0}
                  inputProps={{ 'aria-label': 'Selecionar todos os contatos' }}
                />
              </TableCell>
              <TableCell>Contato</TableCell>
              <TableCell>Telefone</TableCell>
              <TableCell>Tags</TableCell>
              <TableCell>Carteira</TableCell>
              <TableCell>Criado em</TableCell>
              <TableCell>Última mensagem</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {displayedContacts.map((contact) => {
                const isSelected = selectAllMode || selectedContacts.has(contact.id);
                const contactPictureUrl = getContactPictureUrl(contact);
                
                return (
                  <TableRow 
                    key={contact.id}
                    selected={isSelected}
                    className={classes.tableRow}
                  >
                    <TableCell className={classes.checkboxCell}>
                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleSelectContact(contact.id)}
                        disabled={selectAllMode}
                        inputProps={{ 'aria-label': `Selecionar contato ${contact.name}` }}
                      />
                    </TableCell>
                    <TableCell>
                      <div className={classes.contactCell}>
                        <Avatar
                          src={contactPictureUrl}
                          className={classes.clickableAvatar}
                          onClick={() => handleOpenImageModal(contactPictureUrl, contact.name)}
                        >
                          {getInitials(contact.name)}
                        </Avatar>
                        <div>
                          <Typography className={classes.contactName}>{contact.name}</Typography>
                          <Typography className={classes.contactMeta}>
                            {contact.email || formatPhoneNumber(contact)}
                          </Typography>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>{formatPhoneNumber(contact)}</TableCell>
                    <TableCell>
                      <div className={classes.tagWrap}>
                        {contact.tags && contact.tags.length > 0 ? (
                          contact.tags.slice(0, 3).map((tag) => (
                            <Chip
                              key={tag.id || tag.name}
                              size="small"
                              className={classes.tagChip}
                              icon={<LocalOfferIcon style={{ color: tag.color || "#64748b", width: 14 }} />}
                              label={tag.name}
                            />
                          ))
                        ) : (
                          <span className={classes.mutedText}>Sem tags</span>
                        )}
                        {contact.tags && contact.tags.length > 3 && (
                          <Chip size="small" className={classes.tagChip} label={`+${contact.tags.length - 3}`} />
                        )}
                      </div>
                    </TableCell>
                    <TableCell>
                      <span className={contact.contactWallets?.length ? classes.walletText : classes.mutedText}>
                        {getWalletName(contact)}
                      </span>
                    </TableCell>
                    <TableCell>{formatDate(contact.createdAt)}</TableCell>
                    <TableCell>
                      {contact.lastMessage || contact.lastMessageAt || contact.updatedAt
                        ? contact.lastMessage || formatDate(contact.lastMessageAt || contact.updatedAt)
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        className={`${classes.statusBadge} ${contact.active ? classes.activeBadge : classes.blockedBadge}`}
                        label={contact.active ? "Ativo" : "Bloqueado"}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Ações">
                        <IconButton size="small" onClick={(event) => openRowMenu(event, contact)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
              {!loading && displayedContacts.length === 0 && (
                <TableRow>
                  <TableCell colSpan={9}>
                    <div className={classes.emptyState}>Nenhum contato encontrado.</div>
                  </TableCell>
                </TableRow>
              )}
              {loading && <TableRowSkeleton avatar columns={9} />}
            </>
          </TableBody>
        </Table>
      </Paper>

      <Menu
        anchorEl={rowMenuAnchor}
        open={Boolean(rowMenuAnchor)}
        onClose={closeRowMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          disabled={!rowMenuContact?.active}
          onClick={() => handleOpenConversation(rowMenuContact)}
        >
          {rowMenuContact?.channel === "instagram" ? (
            <Instagram fontSize="small" style={{ marginRight: 10, color: "purple" }} />
          ) : rowMenuContact?.channel === "facebook" ? (
            <Facebook fontSize="small" style={{ marginRight: 10, color: "blue" }} />
          ) : (
            <WhatsApp fontSize="small" style={{ marginRight: 10, color: "green" }} />
          )}
          Abrir conversa
        </MenuItem>
        <MenuItem onClick={() => handleOpenDetails(rowMenuContact)}>
          <VisibilityIcon fontSize="small" color="primary" style={{ marginRight: 10 }} />
          Ver detalhes
        </MenuItem>
        <MenuItem
          onClick={() => {
            hadleEditContact(rowMenuContact.id);
            closeRowMenu();
          }}
        >
          <EditIcon fontSize="small" color="primary" style={{ marginRight: 10 }} />
          Editar
        </MenuItem>
        <MenuItem
          onClick={() => {
            setConfirmOpen(true);
            rowMenuContact?.active
              ? setBlockingContact(rowMenuContact)
              : setUnBlockingContact(rowMenuContact);
            closeRowMenu();
          }}
        >
          {rowMenuContact?.active ? (
            <BlockIcon fontSize="small" color="secondary" style={{ marginRight: 10 }} />
          ) : (
            <CheckCircleIcon fontSize="small" color="primary" style={{ marginRight: 10 }} />
          )}
          {rowMenuContact?.active ? "Bloquear" : "Desbloquear"}
        </MenuItem>
        <Can
          role={user.profile}
          perform="contacts-page:deleteContact"
          yes={() => (
            <MenuItem
              onClick={() => {
                setConfirmOpen(true);
                setDeletingContact(rowMenuContact);
                closeRowMenu();
              }}
              style={{ color: "#dc2626" }}
            >
              <DeleteOutlineIcon fontSize="small" style={{ marginRight: 10, color: "#dc2626" }} />
              Excluir
            </MenuItem>
          )}
        />
      </Menu>

      <Dialog
        open={detailsOpen}
        onClose={handleCloseDetails}
        fullWidth
        maxWidth="md"
        className={classes.detailsDialog}
      >
        {detailsContact && (
          <>
            <Box className={classes.detailsHeader}>
              <Avatar
                src={getContactPictureUrl(detailsContact)}
                className={classes.detailsAvatar}
              >
                {getInitials(detailsContact.name)}
              </Avatar>
              <Box flex={1}>
                <Typography variant="h5" style={{ fontWeight: 800 }}>
                  {detailsContact.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {formatPhoneNumber(detailsContact)}
                </Typography>
                <Box mt={1}>
                  <Chip
                    size="small"
                    className={`${classes.statusBadge} ${detailsContact.active ? classes.activeBadge : classes.blockedBadge}`}
                    label={detailsContact.active ? "Ativo" : "Bloqueado"}
                  />
                </Box>
              </Box>
              <Tooltip title="Fechar">
                <IconButton onClick={handleCloseDetails}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Box>
            <DialogContent dividers>
              {detailsLoading ? (
                <Box display="flex" justifyContent="center" p={4}>
                  <Typography color="textSecondary">Carregando detalhes...</Typography>
                </Box>
              ) : (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <div className={classes.detailCard}>
                        <Typography className={classes.detailLabel}>Status</Typography>
                        <Typography className={classes.detailValue}>
                          {detailsContact.active ? "Ativo" : "Bloqueado"}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <div className={classes.detailCard}>
                        <Typography className={classes.detailLabel}>Criado em</Typography>
                        <Typography className={classes.detailValue}>
                          {formatDate(detailsContact.createdAt)}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <div className={classes.detailCard}>
                        <Typography className={classes.detailLabel}>Última mensagem</Typography>
                        <Typography className={classes.detailValue}>
                          {detailsContact.lastMessage ||
                            formatDate(detailsContact.lastMessageAt || detailsContact.updatedAt)}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <div className={classes.detailCard}>
                        <Typography className={classes.detailLabel}>Carteira</Typography>
                        <Typography className={classes.detailValue}>
                          {getWalletName(detailsContact)}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>

                  <Box mt={3}>
                    <Typography variant="subtitle1" style={{ fontWeight: 800 }}>
                      Tags
                    </Typography>
                    <Box mt={1} className={classes.tagWrap}>
                      {detailsContact.tags && detailsContact.tags.length > 0 ? (
                        detailsContact.tags.map((tag) => (
                          <Chip
                            key={tag.id || tag.name}
                            size="small"
                            className={classes.tagChip}
                            icon={<LocalOfferIcon style={{ color: tag.color || "#64748b", width: 14 }} />}
                            label={tag.name}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" className={classes.mutedText}>
                          Sem tags cadastradas.
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {detailsContact.extraInfo && detailsContact.extraInfo.length > 0 && (
                    <Box mt={3}>
                      <Typography variant="subtitle1" style={{ fontWeight: 800 }}>
                        Informações adicionais
                      </Typography>
                      <Box mt={1}>
                        {detailsContact.extraInfo.map((info, index) => (
                          <Box key={`${info.name}-${index}`} py={1}>
                            <Typography variant="body2" className={classes.detailLabel}>
                              {info.name || "Campo"}
                            </Typography>
                            <Typography variant="body1">{info.value || "-"}</Typography>
                            {index < detailsContact.extraInfo.length - 1 && <Divider style={{ marginTop: 8 }} />}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => handleOpenConversation(detailsContact)}
                color="primary"
                variant="outlined"
                disabled={!detailsContact.active}
                startIcon={<OpenInNewIcon />}
                className={classes.actionButton}
              >
                Abrir conversa
              </Button>
              <Button
                onClick={() => {
                  hadleEditContact(detailsContact.id);
                  handleCloseDetails();
                }}
                color="primary"
                variant="outlined"
                startIcon={<EditIcon />}
                className={classes.actionButton}
              >
                Editar
              </Button>
              <Button
                onClick={() => {
                  setConfirmOpen(true);
                  detailsContact.active
                    ? setBlockingContact(detailsContact)
                    : setUnBlockingContact(detailsContact);
                  handleCloseDetails();
                }}
                color="secondary"
                variant="contained"
                startIcon={detailsContact.active ? <BlockIcon /> : <CheckCircleIcon />}
                className={classes.actionButton}
              >
                {detailsContact.active ? "Bloquear" : "Desbloquear"}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </MainContainer>
  );
};

export default Contacts;
